import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-null-security-type",
  // imports: [],
  templateUrl: "./null-security-type.component.html",
  styleUrl: "./null-security-type.component.css",
  standalone: false,
})
export class NullSecurityTypeComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
